//smart event
export default {
    "id": 2444,
    "name_categorie": "Alert",
    "motive_categorie": "entrada",
    "tag": "Jose",
    "eventId": null,
    "deviceId": "f976ab6a-a425-4507-b013-a64f71d8fc45",
    "analytic": "tracker",
    "probability": "0.8057",
    "vinfo": "{\"id\":20,\"name\":\"entrada\",\"state\":true,\"color\":\"#FF0000FF\",\"sound\":\"success\",\"is_active_rules\":null,\"createdAt\":\"2023-08-05T16:53:34.219Z\",\"updatedAt\":\"2023-10-17T19:36:45.512Z\",\"Detail_device_alarm\":[{\"id\":23,\"state\":true,\"createdAt\":\"2023-08-05T16:53:34.230Z\",\"updatedAt\":\"2023-08-05T16:53:34.230Z\",\"alarmId\":20,\"deviceId\":\"f976ab6a-a425-4507-b013-a64f71d8fc45\",\"detail_roi_device\":[{\"id\":23,\"state\":true,\"points\":\"{\\\"point1\\\":[\\\"0.0102\\\",\\\"0.0160\\\"],\\\"point2\\\":[\\\"0.9918\\\",\\\"0.0160\\\"],\\\"point3\\\":[\\\"0.9918\\\",\\\"0.9840\\\"],\\\"point4\\\":[\\\"0.0102\\\",\\\"0.9840\\\"]}\",\"createdAt\":\"2023-08-05T16:53:34.252Z\",\"updatedAt\":\"2023-08-05T16:53:34.252Z\",\"Detail_roi_device_alarmId\":23}],\"detail_schedule_device\":[{\"id\":23,\"state\":null,\"interval\":\"daily\",\"start\":\"05:30:00\",\"end\":\"09:00:00\",\"timeZone\":\"\",\"createdAt\":\"2023-08-05T16:53:34.276Z\",\"updatedAt\":\"2023-08-05T16:53:34.276Z\",\"Detail_shedule_devic\":23}]}],\"Detail_action_alarm\":[{\"id\":20,\"state\":null,\"ismodal\":true,\"isnotificable\":true,\"issendtows\":true,\"issendemail\":true,\"issound\":true,\"isalert\":null,\"manual_confirmation\":false,\"timeout\":null,\"createdAt\":\"2023-08-05T16:53:34.386Z\",\"updatedAt\":\"2023-08-16T16:29:56.323Z\",\"alarmId\":20,\"detail_action_device\":[]}],\"Detail_motion_alarm\":[],\"Detail_rule_face__alarm\":[{\"id\":11,\"state\":true,\"entity\":null,\"access\":\"40\",\"prob\":\"75\",\"idList\":1,\"createdAt\":\"2023-08-05T16:53:34.318Z\",\"updatedAt\":\"2023-10-10T20:03:59.950Z\",\"alarmId\":20}],\"Detail_rule_lpr__alarm\":[],\"Detail_rule_obj_alarm\":[],\"Detail_rule_action_alarm\":[]}",
    "url_evidence": "/alice-media/tracker/10_19_2023/f976ab6a-a425-4507-b013-a64f71d8fc45/10/1697713184235_fullImg.jpg",
    "path_evidence": "/opt/alice-media/tracker/10_19_2023/f976ab6a-a425-4507-b013-a64f71d8fc45/10/1697713184235_fullImg.jpg",
    "bbox": null,
    "unix_itme_stamp": "1697713186119",
    "ruleId": 20,
    "is_confirmed": false,
    "is_ignored": false,
    "is_fp": false,
    "side": "-1",
    "way": "ALL",
    "owner": null,
    "profileId": null,
    "createdAt": "2023-10-19T10:59:46.355Z",
    "updatedAt": "2023-10-19T10:59:46.355Z",
    "Management_incident": [
        {
            "id": 2370,
            "name": "Automatic actions",
            "eventId": 2444,
            "caseId": null,
            "contact": "",
            "userId": 1,
            "deviceId": "17744cb7-9dcf-4be2-a3d7-304f424d3b31",
            "type": "tracker",
            "state": "active",
            "date": "1687519760525",
            "description": "Automatic actions",
            "createdAt": "2023-06-23T11:29:20.537Z",
            "updatedAt": "2023-06-23T11:29:20.537Z",
            "descriptions": []
        },
        {
            "id": 13878,
            "name": "Automatic actions",
            "eventId": 2444,
            "caseId": null,
            "contact": "",
            "userId": 1,
            "deviceId": "f976ab6a-a425-4507-b013-a64f71d8fc45",
            "type": "tracker",
            "state": "active",
            "date": "1697713186119",
            "description": "Automatic actions",
            "createdAt": "2023-10-19T10:59:46.439Z",
            "updatedAt": "2023-10-19T10:59:46.439Z",
            "descriptions": []
        }
    ],
    "userId": 1
}